import './Home.css';
import { useNavigate } from 'react-router-dom';
import logoImage from '../img/tama_logo.bmp';
import product1Img from '../assets/heatcon.PNG';
import product2Img from '../assets/XAutoCon_M1_SF.jpg';
import product3Img from '../assets/PhotoboothIO_M3.png';

function Home() {
  const navigate = useNavigate();

  const productCards = [
    {
      title: '동파방지 열선제어',
      image: product1Img,
      summary: '겨울철 관로 동파를 방지하는 자동 제어 시스템입니다.',
      route: '/services/'
    },
    {
      title: '스마트팜 환경제어',
      image: product2Img,
      summary: '스마트팜 환경제어 시스템은 다양한 센서와 제어기를 통해 작물에 최적화된 환경을 유지하며, 원격으로 모니터링하고 자동화할 수 있는 통합 제어 솔루션입니다',
      route: '/services/smartfarm'
    },
    {
      title: '포토부스 IO박스',
      image: product3Img,
      summary: '포토부스 IO 박스는 무인 포토부스 시스템의 핵심 장치로, 카메라와 결제 장비, 조명, 인쇄 상태 등을 통합적으로 제어할 수 있는 통신 기반 제어 장치입니다.',
      route: '/services/photoboothIO'
    },
    // 다른 제품도 추가 가능
  ];

  return (
    <div className="overview-container">
      <section className="product-summary-section">
        {productCards.map((product, index) => (
          <div key={index} className="product-card">
            <img src={product.image} alt={product.title} className="product-image" />
            <h3>{product.title}</h3>
            <p>{product.summary}</p>
            <button onClick={() => navigate(product.route)}>자세히 보기</button>
          </div>
        ))}
      </section>

      <footer className="home-footer">
        <div><img src={logoImage} alt="Logo" className="tail-logo" /></div>
        <div>서울특별시 금천구 가산디지털1로 75-15 (하우스디와이즈타워, 926-927)</div>
        <div>Tel. 02-448-2871 / Fax. 02-448-2872 / tama@ta-ma.net</div>
        <div>Copyright © 2025 TAMA Co., Ltd. All Rights Reserved.</div>
      </footer>

    </div>
  );
}

export default Home;
